export default "__VITE_ASSET__Cp17j_8z__"